import type { PolicyDetailsResultDTO } from '../../../infrastructure/models';

export const sortPolicyResults = (results: PolicyDetailsResultDTO[] = []): PolicyDetailsResultDTO[] => {
  return [...results].sort((a, b) => {
    const valueIncludesTimekeeping = (value?: string) => value?.toLocaleLowerCase().includes('timekeeping') ?? false;
    const aHasTimekeeping = valueIncludesTimekeeping(a.name) || valueIncludesTimekeeping(a.type);
    const bHasTimekeeping = valueIncludesTimekeeping(b.name) || valueIncludesTimekeeping(b.type);

    if (aHasTimekeeping !== bHasTimekeeping) {
      return aHasTimekeeping ? -1 : 1;
    }

    const typeA = (a.type ?? '').trim().toLocaleLowerCase();
    const typeB = (b.type ?? '').trim().toLocaleLowerCase();

    if (typeA !== typeB) {
      return typeA.localeCompare(typeB);
    }

    return (a.name ?? '').localeCompare(b.name ?? '', undefined, { sensitivity: 'base' });
  });
};
